export const InvestmentCountOptions = [
  { label: "-", value: null },
  { label: "3 or more investments", value: 3 },
  { label: "5 or more investments", value: 5 },
  { label: "10 or more investments", value: 10 },
]